import JalaliDatePicker from './JalaliDatePicker';

export default function JalaliDateRangeFilter({ startDate, endDate, onChange }) {
  const hasRange = Boolean(startDate || endDate);

  const handleStartChange = (value) => {
    onChange({
      startDate: value,
      endDate: value && endDate && value > endDate ? value : endDate,
    });
  };

  const handleEndChange = (value) => {
    onChange({
      startDate: value && startDate && value < startDate ? value : startDate,
      endDate: value,
    });
  };

  return (
    <div className="mt-3 space-y-2">
      <div className="grid grid-cols-2 gap-2">
        <JalaliDatePicker title="از تاریخ" value={startDate} onChange={handleStartChange} />
        <JalaliDatePicker title="تا تاریخ" value={endDate} onChange={handleEndChange} />
      </div>

      {hasRange ? (
        <button
          type="button"
          onClick={() => onChange({ startDate: '', endDate: '' })}
          className="text-[11px] text-slate-500"
        >
          نمایش همه تاریخ‌ها
        </button>
      ) : (
        <p className="text-[11px] text-slate-400">همه تاریخ‌ها</p>
      )}
    </div>
  );
}
